import {FC} from "react";
import {BaseIcon, IPropsIcon} from "./BaseIcon";

interface IProps extends IPropsIcon {

}

export const SearchIcon: FC<IProps> = ({size = 15, fill = 'none'}) => {
    return (
        <BaseIcon size={size} viewBox="0 0 15 15" fill={fill}>
            <path
                d="M13.8906 13.9297L10.3633 10.4023C10.3086 10.3477 10.2266 10.3203 10.1445 10.3203H9.84375C10.8008 9.28125 11.375 7.94141 11.375 6.4375C11.375 3.32031 8.80469 0.75 5.6875 0.75C2.54297 0.75 0 3.32031 0 6.4375C0 9.58203 2.54297 12.125 5.6875 12.125C7.16406 12.125 8.53125 11.5508 9.54297 10.6211V10.8945C9.54297 11.0039 9.57031 11.0859 9.625 11.1406L13.1523 14.668C13.2891 14.8047 13.4805 14.8047 13.6172 14.668L13.8906 14.3945C14.0273 14.2578 14.0273 14.0664 13.8906 13.9297ZM5.6875 11.25C3.00781 11.25 0.875 9.11719 0.875 6.4375C0.875 3.78516 3.00781 1.625 5.6875 1.625C8.33984 1.625 10.5 3.78516 10.5 6.4375C10.5 9.11719 8.33984 11.25 5.6875 11.25Z"
                fill="#7D8286"
            />
        </BaseIcon>
    )
}